import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { TableConfig } from '@app/shared/util/table-config.utils';

import { ToolReturn } from '@models/tool-return.model';
import { ToolReturnsService } from '@services/tool-returns.service';

import { Log } from 'ng2-logger';
import { NotificationService } from "@services/notification.service";
import { Subscription } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
import { ToolRequestStatus } from "@app/tool/model/enums/tool-request-status.enum";
import { Section } from "@models/enums/section.utils";
import { AppUtils } from '@app/shared/util/app.utils';

@Component({
    selector: 'app-tool-returns',
    templateUrl: './tool-returns.component.html',
    styleUrls: ['./tool-returns.component.scss']
})
export class ToolReturnsComponent implements OnInit, OnDestroy {

    _logger = Log.create(ToolReturnsComponent.name);

    toolReturns: ToolReturn[] = [];
    tableConfig = new TableConfig();
    isLoading = false;

    newToolRequestsSubscription: Subscription;

    filterStatusList = [];

    basePath = 'tool-returns-lines';
    selectedPlantsChangedSubscription: Subscription;

    constructor(private toolReturnsService: ToolReturnsService,
                private router: Router,
                private notificationService: NotificationService,
                private route: ActivatedRoute,
                private translateService: TranslateService) {
        this.filterStatusList = this.buildStatusFilterColumnKeys();
        this.translateService.onLangChange.subscribe((event) => {
            this.filterStatusList = this.buildStatusFilterColumnKeys();
        });
        this.selectedPlantsChangedSubscription = this.notificationService.selectedPlantsChangedAsObservable.subscribe(data => {
            this.getToolReturns(this.tableConfig);
        });
    }

    ngOnInit() {
        this.getToolReturns(this.tableConfig);
        this.newToolRequestsSubscription = this.notificationService.toolReturnsQueueObservable.subscribe((value) => {
            if (value) {
                this._logger.info("ngOnInit:: toolReturnsQueueSubscription got value", value);
                this.getToolReturns(this.tableConfig);
            }
        });
    }

    ngOnDestroy(): void {
        if (this.newToolRequestsSubscription) {
            this.newToolRequestsSubscription.unsubscribe();
        }
        if (this.selectedPlantsChangedSubscription) {
            this.selectedPlantsChangedSubscription.unsubscribe();
        }
    }

    getToolReturns(tableConfig = this.tableConfig) {
        this._logger.info('getToolReturns:: Retrieving tool returns ');
        this.isLoading = true;
        tableConfig = AppUtils.appendPlantsQuery(tableConfig);
        this.toolReturnsService.getAllToolReturns(tableConfig, 'LINE', Section.ApproveToolReturns).subscribe(
            (data) => {
                this._logger.info('getToolReturns:: API Returned data', data);
                this.toolReturns = data.items;
                this.tableConfig.pager.count = data.total;
                this.isLoading = false;
            },
            (error) => {
                this._logger.error('getToolReturns:: API Returned error', error);
                this.isLoading = false;
            }
        )
    }

    onSortChange(tableState) {
        this.getToolReturns(tableState);
    }

    onPageChange(tableState) {
        this.getToolReturns(tableState);
    }

    onFilter(tableConfig: TableConfig) {
        this.getToolReturns(tableConfig);
    }

    onActionClick(action: any) {
        if (action.startProcess) {
            this.toolReturnsService.processToolReturn(action.toolReturn).subscribe(
                (data) => {
                    this._logger.info('processToolReturn:: API Returned data', data);
                },
                (error) => {
                    this._logger.error('processToolReturn:: API Returned error', error);
                }
            );
        }
        this.router.navigate([`${this.basePath}/${action.toolReturn.id}`]);
    }

    buildStatusFilterColumnKeys() {
        return [
            {name: this.translateService.instant("generic.statuses.all"), value: 'All'},
            {
                name: this.translateService.instant("generic.statuses.approved"),
                value: ToolRequestStatus.APPROVED
            },
            {
                name: this.translateService.instant("generic.statuses.waitingForProcessing"),
                value: ToolRequestStatus.WAITING_FOR_PROCESSING
            },
        ];
    }
}
